import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { signatureFavorites } from "@/data/favorites";
import { useLang, pick } from "@/lib/i18n";
import { OrderButton } from "@/components/TrackedLinks";

export const SignatureFavorites = () => {
  const { t, lang } = useLang();
  return (
    <section className="py-24 px-4 bg-hacienda-cream" data-testid="favorites-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-14">
          <p className="text-hacienda-terracotta text-sm uppercase tracking-[0.2em] mb-4">{t("favorites.eyebrow")}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-hacienda-charcoal font-semibold leading-tight mb-4">{t("favorites.title")}</h2>
          <p className="text-hacienda-gray text-lg">{t("favorites.sub")}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {signatureFavorites.map((item) => (
            <article key={item.key} className="group bg-white rounded-2xl overflow-hidden border border-hacienda-border-light shadow-sm hover:shadow-xl transition-shadow flex flex-col" data-testid={`favorite-card-${item.key}`}>
              <div className="aspect-[4/3] overflow-hidden relative">
                <img src={item.image} alt={item.alt} loading="lazy" decoding="async" width="600" height="450" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute top-3 left-3 bg-hacienda-charcoal/85 text-hacienda-cream text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full">{pick(item.tag, lang)}</span>
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-start justify-between gap-3 mb-2">
                  <h3 className="font-serif text-2xl text-hacienda-charcoal font-semibold">{pick(item.name, lang)}</h3>
                  <span className="text-hacienda-terracotta font-bold whitespace-nowrap">{item.price || t("actions.viewOptions")}</span>
                </div>
                <p className="text-hacienda-gray text-sm leading-relaxed flex-grow">{pick(item.description, lang)}</p>
                <div className="mt-5 flex items-center gap-3">
                  {item.link ? (
                    <Link to={item.link} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-hacienda-terracotta text-white text-sm font-medium hover:bg-hacienda-terracotta-dark transition-colors" data-testid={`favorite-link-${item.key}`}>
                      {t("actions.quote")} <ArrowRight size={16} aria-hidden="true" />
                    </Link>
                  ) : (
                    <OrderButton location={`favorite_${item.key}`} size="sm" data-testid={`favorite-order-${item.key}`} />
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
